import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import "@/filters/converters";
import "@/filters/string";
import "@/utilities/prototype";

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
